import React from 'react';
import CrossRoad from "../UI/Crossroad";

const Crossroad_JBlue_13EBlue = () => <CrossRoad coords="1783.000000, 1161.000000"/>;

export default Crossroad_JBlue_13EBlue;
